const post = {
  id: 2,
  title: 'Why I Chose Java as My Foundation',
  date: 'January 2024',
  excerpt: "When I started at Codeup, Java felt overwhelming and verbose. Two years later it's my strongest language and the backbone of my career. Here's what finally clicked.",
  body: `Java gets a bad reputation for being verbose. When I was learning it at Codeup, I spent the first few weeks wondering why we weren't just doing JavaScript everything.

Then Spring Boot clicked.

When you understand what the framework is doing — dependency injection, inversion of control, the whole container lifecycle — Java stops feeling like ceremony and starts feeling like power. You're not writing boilerplate; you're describing a system.

At CGI, working on large-scale federal applications, Java's verbosity became a feature. Every type is declared. Every contract is explicit. When you come back to code six months later, or when a new team member picks it up, it reads like documentation.

My advice to anyone starting out: don't fight the language. Understand why it was built the way it was. Java has been running the backend of the internet for 30 years for a reason.`,
  readTime: '4 min read',
  tags: ['Java', 'Learning', 'Dev'],
};

export default post;
